import {makeSystemModePath} from './shared/serverFunctions';

/**
 * Combined Sales
 *      All
 *      by: DBA, Location, Locations, District
 *      by: State, State & City, State & DBA
 */
export const RESOURCES = {
    "CombinedSalesAll": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Combined Sales",
                "uri": localStorage.getItem('server') + "/api/v5/report/payments/" + systemMode + "/getPaymentTotalsByDateRange/" + startEndOffset
            }
        }
    },
    "CombinedSalesByDba": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Combined Sales by DBA",
                "uri": localStorage.getItem('server') + "/api/v5/report/payments/" + systemMode + "/getPaymentTotalsByDBADateRange/" + params.dba_id + "/" + startEndOffset
            }
        }
    },
    "CombinedSalesByLocation": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Combined Sales by Location",
                "uri": localStorage.getItem('server') + "/api/v5/report/payment/" + systemMode + "/" + params.location_id + "/getLocSummaryByDateRange/" + startEndOffset
            }
        }
    },
    "CombinedSalesByLocations": {
        UPDATE: function(params) {
            let systemMode = makeSystemModePath();
            return {
                "type": "POST",
                "data": params,
                "uri": localStorage.getItem('server') + "/api/v5/report/payments/" + systemMode + "/getPaymentTotalsByLocDateRange"
            }
        }
    },
    "CombinedSalesByDistrict": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Combined Sales by District",
                "uri": localStorage.getItem('server') + "/api/v5/report/payments/" + systemMode + "/getPaymentTotalsByDistDateRange/" + params.district_id + "/" + startEndOffset
            }
        }
    },
    "CombinedSalesByState": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Combined Sales by State",
                "uri": localStorage.getItem('server') + "/api/v5/report/payments/" + systemMode + "/getPaymentTotalsByStateDateRange/" + params.state + "/" + startEndOffset
            }
        }
    },
    "CombinedSalesByStateCity": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Combined Sales by City & State",
                "uri": localStorage.getItem('server') + "/api/v5/report/payments/" + systemMode + "/getPaymentTotalsByStCityDateRange/" + params.state + "/" + params.city + "/" + startEndOffset
            }
        }
    },
    "CombinedSalesByStateDBA": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Combined Sales by City & DBA",
                "uri": localStorage.getItem('server') + "/api/v5/report/payments/" + systemMode + "/getPaymentTotalsByStDBADateRange/" + params.state + "/" + params.dba_id + "/" + startEndOffset
            }
        }
    }
};

export default (type, resource, params) => {

    /**
     * @param {string} type Request type, e.g. GET_LIST
     * @param {string} resource Resource name, e.g. "CombinedSalesAll"
     * @param {Object} payload Request parameters. Depends on request type
     * @returns {Object} RESOURCES object
     */
    return (type, resource, params) => {
        return RESOURCES;
    }
}



// WEBPACK FOOTER //
// ./src/Fuse/fuseCombinedSalesReportsResourceMap.js